var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"appDescription"},[_vm._v(" "+_vm._s(_vm.description)+" "),_c('a',{attrs:{"href":_vm.manualLink,"target":"_blank","rel":"nofollow"}},[_vm._v(_vm._s(_vm.$t("WorkspaceEdit.appCard.label.openManual")))])])}
var staticRenderFns = []

export { render, staticRenderFns }